import { DOCUMENT } from '@angular/common';
import { Injectable, inject } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';
import { filter, tap } from 'rxjs/operators';

/**
 * Applies a new service worker version by reloading the page.
 *
 * `VERSION_READY` just marks the update as pending; the reload happens once,
 * on the next route navigation, so it never hits the user mid-input.
 * An unrecoverable service worker state reloads immediately.
 */
@Injectable({ providedIn: 'root' })
export class SwUpdatePromptService {
  private readonly swUpdate = inject(SwUpdate);
  private readonly router = inject(Router);
  private readonly document = inject<Document>(DOCUMENT);

  private pending = false;

  init(): void {
    if (!this.swUpdate.isEnabled) {
      return;
    }

    this.swUpdate.versionUpdates
      .pipe(
        // TODO: remove debug
        tap(event => console.info('[qtek] SW Update: ', event)),
        filter((evt): evt is VersionReadyEvent => evt.type === 'VERSION_READY')
      )
      .subscribe(() => (this.pending = true));

    this.router.events
      .pipe(filter(evt => evt instanceof NavigationEnd))
      .subscribe(() => {
        if (this.pending) {
          // ngsw serves the latest version to any new
          // navigation request (reload, reopened tab/window).
          this.pending = false;
          this.document.location.reload();
        }
      });

    this.swUpdate.unrecoverable.subscribe(() =>
      this.document.location.reload()
    );
  }
}
